import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import Logo from './Logo';

const Footer = () => {
  const { t } = useTranslation();
  
  return (
    <footer className="bg-[#0B0B0C] border-t border-[#27272A]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-0">
            <Link to="/">
              <Logo size="footer" />
            </Link>
            <p className="text-zinc-400 text-sm">
              {t('footer.description')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-white mb-4 uppercase tracking-wide text-sm">{t('footer.quickLinks')}</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/menu" className="text-zinc-400 hover:text-[#FFC107] text-sm transition-colors">
                  {t('footer.ourMenu')}
                </Link>
              </li>
              <li>
                <Link to="/login" className="text-zinc-400 hover:text-[#FFC107] text-sm transition-colors">
                  {t('footer.account')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-zinc-400 hover:text-[#FFC107] text-sm transition-colors">
                  {t('footer.contactUs')}
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-zinc-400 hover:text-[#FFC107] text-sm transition-colors">
                  {t('footer.privacyPolicy')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-white mb-4 uppercase tracking-wide text-sm">{t('footer.contactUs')}</h4>
            <ul className="space-y-3">
              <li>
                <a href={`tel:${t('contactInfo.phoneNumber').replace(/\s/g, '')}`} className="flex items-center gap-2 text-zinc-400 hover:text-[#FFC107] text-sm transition-colors">
                  <Phone className="h-4 w-4 text-[#FFC107]" />
                  {t('contactInfo.phoneNumber')}
                </a>
              </li>
              <li>
                <a href={`mailto:${t('contactInfo.emailAddress')}`} className="flex items-center gap-2 text-zinc-400 hover:text-[#FFC107] text-sm transition-colors">
                  <Mail className="h-4 w-4 text-[#FFC107]" />
                  {t('contactInfo.emailAddress')}
                </a>
              </li>
              <li>
                <a href={`https://maps.google.com/?q=${encodeURIComponent(t('contactInfo.street') + ', ' + t('contactInfo.city'))}`} target="_blank" rel="noopener noreferrer" className="flex items-start gap-2 text-zinc-400 hover:text-[#FFC107] text-sm transition-colors">
                  <MapPin className="h-4 w-4 text-[#FFC107] shrink-0 mt-0.5" />
                  {t('contactInfo.street')}, {t('contactInfo.city')}
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="font-semibold text-white mb-4 uppercase tracking-wide text-sm">{t('footer.hoursTitle')}</h4>
            <ul className="space-y-1.5 text-sm">
              <li className="text-zinc-400">{t('footer.monday')}</li>
              {t('footer.tuesday') && <li className="text-zinc-400">{t('footer.tuesday')}</li>}
              {t('footer.saturday') && <li className="text-zinc-400">{t('footer.saturday')}</li>}
            </ul>
          </div>
        </div>

        <div className="border-t border-[#27272A] mt-8 pt-8 text-center text-zinc-500 text-sm">
          <p>{t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
